<!--
  交易任务规则弹窗
  结构和入金弹窗一致，差异：标题文案、表格上方图标（icon-trad）、表格只有一行
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import BottomSheet from "./BottomSheet.svelte";
  import balloon from "../assets/images/dialog/balloon.png";
  import tradeIcon from "../assets/images/dialog/icon-trad.png";
  import underline from "../assets/images/dialog/deco-underline.png";
  import star from "../assets/images/dialog/deco-star.png";

  interface Props {
    show: boolean;
    onClose: () => void;
  }

  let { show, onClose }: Props = $props();
</script>

<BottomSheet {show} {onClose}>
  <!-- 气球：压在弹窗左上角并向上溢出 -->
  <img src={balloon} alt="" class="dlg-balloon" />

  <!-- 标题：交易（金色）+ 任务规则（白色） -->
  <div class="dlg-title-wrap">
    <h2 class="dlg-title">
      <span class="dlg-title-hl">{$t("trade_rule_title_hl")}</span
      >{$t("trade_rule_title")}
    </h2>
    <img src={underline} alt="" class="dlg-title-line" />
    <img src={star} alt="" class="dlg-title-star is-right" />
    <img src={star} alt="" class="dlg-title-star is-left" />
  </div>

  <!-- 白色内容卡 -->
  <div class="dlg-card">
    <img src={tradeIcon} alt="" class="dlg-trade-icon" />

    <p class="dlg-card-title">{$t("guide_title")}</p>

    <div class="dlg-table">
      <div class="dlg-row">
        <span class="dlg-cell-left">
          <span class="dlg-cell-text">{$t("trade_tier_1")}</span>
        </span>
        <span class="dlg-cell-right">
          <span class="dlg-cell-text">{$t("trade_tier_1_code")}</span>
        </span>
      </div>
    </div>

    <p class="dlg-max">{$t("trade_max")}</p>
    <p class="dlg-note">{$t("trade_note")}</p>
  </div>

  <button type="button" class="grad-btn dlg-confirm" onclick={onClose}>
    {$t("btn_confirm")}
  </button>
</BottomSheet>

<style>
  /* 气球 152x258@2x = 76x129，向上溢出弹窗顶边 */
  .dlg-balloon {
    position: absolute;
    top: -26px;
    left: -4px;
    width: 76px;
    height: 129px;
  }

  /* 顶部间距由弹窗的 padding-top 26px 提供，这里只留标题到白卡的距离 */
  .dlg-title-wrap {
    position: relative;
    padding-bottom: 6px;
    text-align: center;
  }

  /* 标题（设计稿）：20px / 700 / line-height 20px / shadow 0 2px 2px #165BFD */
  .dlg-title {
    position: relative;
    z-index: 1;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 2px #165bfd;
  }

  /* 高亮部分「交易」：#FFDF00 */
  .dlg-title-hl {
    color: #ffdf00;
  }

  /* 标题笔画 149x18@2x = 74.5x9，压在标题右下方 */
  .dlg-title-line {
    position: absolute;
    bottom: -6px;
    left: 50%;
    width: 74.5px;
    height: 9px;
    margin-left: 7px;
  }

  /* 小星星 16x16@2x = 8x8 */
  .dlg-title-star {
    position: absolute;
    left: 50%;
    width: 8px;
    height: 8px;
  }

  .dlg-title-star.is-right {
    top: -2px;
    margin-left: 82px;
    transform: rotate(-20deg);
  }

  .dlg-title-star.is-left {
    top: 21px;
    margin-left: -91px;
    transform: rotate(15deg);
  }

  .dlg-card {
    position: relative;
    margin-top: 15px;
    padding: 12px;
    border-radius: 16px;
    background: #ffffff;
  }

  /* 交易图标：设计稿 69x61，压在白卡右上角 */
  .dlg-trade-icon {
    position: absolute;
    top: -13px;
    right: 8px;
    width: 69px;
    height: 61px;
  }

  /* 获取攻略（设计稿）：16px / 600 / line-height 24px / #003EC7 */
  .dlg-card-title {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    color: #003ec7;
  }

  /* 表格：底色 #F3FAFF，边框统一 #ABDEFF */
  .dlg-table {
    margin-top: 12px;
    border: 1px solid #abdeff;
    border-radius: 8px;
    background: #f3faff;
    overflow: hidden;
  }

  /* 行高固定 52px */
  .dlg-row {
    display: flex;
    align-items: stretch;
    height: 52px;
  }

  /* 单元格都垂直居中 */
  .dlg-cell-left,
  .dlg-cell-right {
    display: flex;
    align-items: center;
  }

  /* 左列：固定 210px，文字可换行 */
  .dlg-cell-left {
    flex: none;
    width: 210px;
    padding: 8px 15.5px;
  }

  /* 右列：占满剩余宽度，不换行 */
  .dlg-cell-right {
    flex: 1;
    min-width: 0;
    padding: 17px 28px;
    border-left: 1px solid #abdeff;
  }

  .dlg-cell-right .dlg-cell-text {
    white-space: nowrap;
  }

  /*
    表格文字（设计稿）：14px / 400 / line-height 22px / #001746
    单独一层撑满宽度，换行后每一行都能水平居中
  */
  .dlg-cell-text {
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    color: #001746;
    text-align: left;
  }

  .dlg-max {
    margin-top: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #001746;
  }

  /* 备注（设计稿）：14px / 400 / line-height 150% / #001746 */
  .dlg-note {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: #001746;
    text-align: justify;
    text-justify: inter-ideograph;
  }

  /* 渐变底 + 1.5px 渐变描边 + 内阴影同任务按钮，见 app.css 的 .grad-btn */
  .dlg-confirm {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
</style>
